export enum UserStatus {
  ONLINE = 'online',
  OFFLINE = 'offline',
  AWAY = 'idle',
  INVISIBLE = 'invisible',
  BUSY = 'busy',
  UNREAD = 'unread',
}

export type CustomStatus = {
  text?: string;
  icon?: string;
  status?: UserStatus;
};
